<template>
  <div class="container">
    <p class="buttons is-pulled-right">
      <button class="button is-secondary is-rounded" @click="create">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>{{ $t("add") }}</span>
      </button>
    </p>
    <h5 class="title is-5 pt-3">{{ $t("transactions") }}</h5>
    <table class="table is-bordered is-fullwidth" v-if="transactions">
      <thead>
        <tr>
          <th>{{ $t("account") }}</th>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("debit") }}</th>
          <th>{{ $t("credit") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rsrc, ridx) in transactions" :key="ridx">
          <td>
            <generic-dropdown
              :show_title="false"
              :placeholder="$t('account')"
              :is_multiple="false"
              url="/accounting/account/catalog"
              name_field="name"
              value_field="account_id"
              @selected="set_account($event, ridx)"
              ref="account_dropdown"
              :extra_data="{ uuid: $route.params.period_uuid }"
            />
            <!-- <input
              type="text"
              class="input"
              v-model="transactions[ridx].account_id"
            /> -->
          </td>
          <td>
            <input
              type="text"
              class="input"
              v-model="transactions[ridx].name"
            />
          </td>
          <td>
            <input
              type="text"
              class="input"
              v-model="transactions[ridx].debit"
            />
          </td>
          <td>
            <input
              type="text"
              class="input"
              v-model="transactions[ridx].credit"
            />
          </td>
          <td>
            <button
              class="button is-secondary has-text-danger is-rounded"
              @click="delete_transaction(ridx)"
              :data-tooltip="$t('delete')"
            >
              <span class="icon">
                <i class="fa fa-trash"></i>
              </span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { confirm_deletion_dialog, del } from "@/utils";

export default {
  name: "Transactions",
  components: { GenericDropdown },
  data() {
    return {
      transactions: [],
    };
  },
  computed: {
    total_debit() {
      let v = this;
      let total = 0;
      if (v.transactions) {
        total = v.transactions.reduce((acc, cur) => {
          return acc + Number(cur.debit);
        }, 0);
      }
      return total;
    },
    total_credit() {
      let v = this;
      let total = 0;
      if (v.transactions) {
        total = v.transactions.reduce((acc, cur) => {
          return acc + Number(cur.credit);
        }, 0);
      }
      return total;
    },
  },
  methods: {
    create() {
      let v = this;

      v.transactions.push({
        name: "",
        account_id: "",
        debit: 0,
        credit: 0,
      });
    },
    set_account(account, index) {
      let v = this;
      v.transactions[index].account_id = account.account_id;
    },
    clear() {
      let v = this;
      v.transactions = [];
    },
    get_transactions() {
      let v = this;
      return v.transactions;
    },
    set_transactions(transactions) {
      let v = this;
      v.transactions = transactions;
    },
    delete_transaction(index) {
      let v = this;
      let trgt = v.transactions[index];
      if (trgt.uuid) {
        confirm_deletion_dialog(
          v.$t("are you sure to delete transaction?"),
          v,
          () => {
            del("/accounting/transaction", { uuid: trgt.uuid })
              .then(() => {
                v.transactions.splice(index, 1);
              })
              .catch((error) => {
                console.error(error);
              });
          }
        );
      } else {
        v.transactions.splice(index, 1);
      }
    },
  },
  mounted() {},
  watch: {
    total_debit: function (val) {
      let v = this;
      v.$emit("total", { debit: val, credit: v.total_credit });
    },
    total_credit: function (val) {
      let v = this;
      v.$emit("total", { debit: v.total_debit, credit: val });
    },
  },
};
</script>

<style scoped></style>
